import { createSelector } from '@ngrx/store';
import { CheckoutOrderState } from '../reducers/checkout-order.reducer';
import { getOrderCheckoutState, OrderCheckoutState } from '../reducers/index';

const getCheckoutOrderState = createSelector(
  getOrderCheckoutState,
  (state: OrderCheckoutState) => state.checkoutOrder,
);

export const getCheckoutOrderError = createSelector(
  getCheckoutOrderState,
  (state: CheckoutOrderState) => state.error,
);

export const getCheckoutOrderLoading = createSelector(
  getCheckoutOrderState,
  (state: CheckoutOrderState) => state.loading,
);
